import styled from "styled-components";

export const StyledTables = styled.div`
  z-index: 2000;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5% 0 5% 0;

  @media (max-width: 1050px) {
    padding: 5% 0 100px 0;
  }
`;

export const TablesWrapper = styled.div`
  width: 1600px;
  max-width: 100%;
  padding: 0 40px 80px 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const WinnersTables = styled.div`
  width: 45.5%;
  padding: 0;
  min-height: 10vh;

  @media (max-width: 1050px) {
    width: 100%;
    padding: 20px 0;
  }
`;

export const WinnerTitles = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: flex-end;
`;

export const TableTitlePar = styled.p`
  float: left;
  font-weight: 500;
  color: var(--switchfill);
  text-align: center;
  font-size: 24px;
  letter-spacing: 1.5px;

  @media (max-width: 650px) {
    font-size: 12px;
    letter-spacing: 0px;
  }

  @media (max-width: 1100px) {
    font-size: 16px;
    letter-spacing: 0.75px;
  }
`;

export const WinnerWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  height: 100%;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) =>
      theme.skin === "pub"
        ? "#9A875D"
        : theme.skin === "cac" || theme.skin === "hyc"
        ? "#AAA2A5"
        : theme.skin === "rac"
        ? "var(--scollbarCac)"
        : "var(--footerTextColor)"};
    border-radius: 5px;
    border: 0px solid var(--scrollbarBG);
  }
`;

export const WinnerImg = styled.div`
  height: 25%;
  background-image: url(data:image/png;base64,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);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-top: 4.5%;
  picture {
    width: 28%;
    source,
    img {
      width: 100%;
    }
  }
`;

export const Winner = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 80%;
  box-sizing: border-box;
  padding-bottom: 10px;
`;

export const WinnerText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  min-height: 35%;
  box-sizing: border-box;
  padding-left: 10px;
`;

export const WinnerAmount = styled.h3`
  /* font-family: "Catamaran", Fallback, sans-serif; */
  font-weight: 800;
  font-size: 37px;
  align-self: start;
  color: var(--tabletext);
  margin-top: 2px;
  text-align: left;
  padding-left: 3%;

  @media (max-width: 650px) {
    font-size: 15px;
    margin-top: 0px;
  }

  @media (max-width: 1100px) {
    font-size: 26px;
    margin-top: 2px;
    width: 120px;
  }
`;

export const WinnerDetails = styled.div`
  align-self: start;
  /* font-family: "Catamaran", Fallback, sans-serif; */
  font-weight: 500;
  padding-left: 5%;
  color: var(--carouseltext);

  @media (max-width: 650px) {
    font-size: 12px;
  }
  @media (max-width: 1050px) {
    font-size: 14px;
    width: 100%;
  }
`;

export const StyledPlayNow = styled.img`
  width: 150px;
  transition: all 0.2s ease;
  pointer-events: auto;
  cursor: pointer;

  :hover {
    transform: scale(1.1);
  }

  @media (max-width: 650px) {
    width: 80px;
  }
`;

export const StyledTournamentTable = styled.div`
  width: 45.5%;
  padding: 0;
  min-height: 60vh;
  box-sizing: border-box;
  & > div {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    align-content: flex-end;
    .showall {
      cursor: pointer;
      float: right;
      font-weight: 500;
      color: var(--showall);
      text-align: center;
    }
  }

  @media (max-width: 1050px) {
    width: 100%;
    padding: 20px 0;
  }
`;

export const SeceontTableTitle = styled.div`
  padding-top: 80px;
`;

export const StyledTableTournament = styled.table.attrs({
  id: "tournaments",
})`
  border-collapse: collapse;
  width: 100%;
  padding: 0 10px;
  tbody {
    display: block;
    height: 560px;
    width: 100%;
  }

  td {
    color: var(--tabletext);
    /* font-family: "Catamaran", Fallback, sans-serif; */
    font-weight: 500;
    font-size: 14px;
    padding: 0px;
  }

  th {
    color: #709fff;
    /* font-family: "Catamaran", Fallback, sans-serif; */
    font-weight: 500;
    font-size: 14px;
    padding: 0px;
  }

  tr {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 650px) {
    td,
    th {
      font-size: 12px;
    }
  }
`;

export const ShowAll = styled.p`
  cursor: pointer;
  float: right;
  font-weight: 500;
  color: var(--showall);
  text-align: center;
`;
